import type { Except } from "type-fest";
import type { IsoAndUnixTimestamp } from "../date-time/iso-and-unix";
import { nowIsoAndUnix } from "../date-time/iso-and-unix";
import type { OwnerId } from "../owner-id";
import type { ZettleId } from "./zettle-id";
import { ZettleIdFactory } from "./zettle-id";

type ZettleToken = {
    _id: ZettleId;
    _type: "ZETTLE_TOKEN";
    _createdAt: IsoAndUnixTimestamp;
    ownerId: OwnerId;

    token: {
        _createdAt: IsoAndUnixTimestamp;
        accessToken: string;
        expiresIn: IsoAndUnixTimestamp;
        refreshTokenExpiresAt: IsoAndUnixTimestamp;
    };
};

type params = Except<ZettleToken, "_id" | "_type" | "_createdAt">;
const ZettleFactory = (params: params) => {
    const command: ZettleToken = {
        ...params,
        _id: ZettleIdFactory(),
        _type: "ZETTLE_TOKEN",
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};

export { ZettleFactory };
export type { ZettleToken };
